module.exports = __webpack_public_path__ + "static/media/bin.bb37d16f.svg";